export default __webpack_public_path__ + "static/media/BEAT.a9fbe6b013af10b65baa8e8c3878a621.webp";